import { Button } from "@/components/ui/button";

export function ScannerEmptyState() {
  const goToPages = () => {
    const base = window.wyA11yGlobals?.adminUrl || "/wp-admin/";
    window.location.href = `${base.replace(/\/?$/, "/")}edit.php?post_type=page`;
  };

  return (
    <div
      className={
        "cy:bg-white cy:border cy:border-[#cacee4] cy:rounded-[12px] cy:px-8 cy:py-6 " +
        "cy:flex cy:flex-col cy:items-center cy:justify-center cy:gap-8 cy:min-h-[328px]"
      }
    >
      <div className="cy:flex cy:flex-col cy:gap-2 cy:items-start cy:w-full">
        <h2 className="cy:font-bold cy:text-[20px] cy:text-[#21242d] cy:tracking-[-0.4px]">
          No auditable URLs found.
        </h2>
        <p className="cy:text-[14px] cy:text-[#4e4b66] cy:tracking-[-0.28px]">
          Publish at least one page or post so visitors have somewhere to land.
        </p>
      </div>
      <div className="cy:w-full">
        <Button
          type="button"
          onClick={goToPages}
          className="cy:bg-[#0b66e4] cy:hover:bg-[#0b66e4]/90 cy:text-white cy:rounded-[3px] cy:h-[44px] cy:px-3"
        >
          Go to pages
        </Button>
      </div>
    </div>
  );
}
